import axios from '@/assets/js/api'

/**
 * xlsx数据导出
 * meod 参数 string (请求方式)
 * meod 参数 string (请求地址)
 * meod 参数 obj    (请求参数)
 * meod 参数 string (xlsx文件名)
 * meod 参数 function (回调)
 */
const downloadExcel=function(meod,url,params,name,cb){        //下载：方式，地址，参数，文件名，回调
    axios.defaults.responseType='blob';
    return axios[meod](url,params).then(v=>{
        if(v.status === 200){
            const blob = new Blob([v.data]);
            const fileName = name+'.xlsx';
            const elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
        }
        cb && cb(v)
        axios.defaults.responseType='json';
    }).catch(v=>{
        axios.defaults.responseType='json';
    })
    axios.defaults.responseType='json';
}

export { 
    downloadExcel,
}